import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import Forbidden from "./Forbidden";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-forbidden")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Forbidden />
		</ThemeProvider>
	</StrictMode>
);
